import defaultTheme from "./default";
import { createMuiTheme } from "@material-ui/core";

const overrides = {
  typography: {
    h1: {
      fontSize: "3rem",
    },
    h2: {
      fontSize: "2rem",
    },
    h3: {
      fontSize: "1.64rem",
    },
    h4: {
      fontSize: "1.5rem",
    },
    h5: {
      fontSize: "1.285rem",
    },
    h6: {
      fontSize: "1.142rem",
    },
  },
};

// 전체 폰트를 설정하려면 'fontFamily' 속성 추가
const themes = {
  default: createMuiTheme({
    ...defaultTheme,
    ...overrides, // 커스터마이즈된 typography 추가
  }),
};

export default themes;
